/** The paying side's strings, spread into the accounting namespace (accounting:bill…) */

export const payablesTh = {
  opening: {
    title: 'ยกยอดเริ่มต้น',
    hint: 'ลูกหนี้และเจ้าหนี้ที่ยังค้าง ณ วันเปิดใช้ จากโปรแกรมเก่าหรือ Excel ใช้เลขที่เอกสารเดิม ไม่ออกใบกำกับภาษีใหม่ และไม่เข้ารายงานภาษีซื้อหรือสมุดรายวัน',
    kinds: { receivables: 'ลูกหนี้ค้างรับ', payables: 'เจ้าหนี้ค้างจ่าย' },
    kindHints: {
      receivables: 'ใบแจ้งหนี้ที่ลูกค้ายังไม่จ่าย รับชำระต่อในระบบได้ตามปกติ',
      payables: 'ใบตั้งหนี้ที่ยังไม่ได้จ่ายผู้ขาย เข้ามาเป็น "รออนุมัติ" ผู้จัดการอนุมัติแล้วจ่ายต่อด้วยใบสำคัญจ่ายได้',
    },
    col: {
      customerCode: 'รหัสลูกค้า',
      vendorCode: 'รหัสผู้ขาย',
      number: 'เลขที่เอกสารเดิม',
      issueDate: 'วันที่เอกสาร',
      billDate: 'วันที่เอกสาร',
      dueDate: 'ครบกำหนด',
      amount: 'ยอดค้าง (รวม VAT)',
      wht: 'หัก ณ ที่จ่าย',
      notes: 'หมายเหตุ',
    },
  },
  account: {
    title: 'บัญชี',
    plural: 'ผังบัญชี',
    create: 'เพิ่มบัญชี',
    fields: { code: 'รหัสบัญชี', name: 'ชื่อบัญชี', type: 'หมวด', system: 'ระบบลงบัญชี', status: 'สถานะ', notes: 'หมายเหตุ' },
    options: {
      type: { asset: 'สินทรัพย์', liability: 'หนี้สิน', equity: 'ส่วนของเจ้าของ', revenue: 'รายได้', expense: 'ค่าใช้จ่าย' },
      status: { active: 'ใช้งาน', inactive: 'เลิกใช้' },
    },
    hint: 'บัญชีที่ระบบลงให้เองเปลี่ยนชื่อได้ แต่เปลี่ยนรหัสหรือหมวดไม่ได้ ใบตั้งหนี้เลือกได้ทุกบัญชีค่าใช้จ่าย',
  },
  bill: {
    title: 'ใบตั้งหนี้',
    plural: 'ใบตั้งหนี้ / ค่าใช้จ่าย',
    create: 'บันทึกค่าใช้จ่าย',
    fields: {
      number: 'เลขที่',
      vendorId: 'ผู้ขาย',
      billDate: 'วันที่',
      dueDate: 'ครบกำหนดจ่าย',
      vendorInvoiceNo: 'เลขที่ใบกำกับภาษี / ใบแจ้งหนี้ผู้ขาย',
      vendorInvoiceDate: 'วันที่ใบกำกับภาษี',
      lines: 'รายการ',
      attachments: 'เอกสารแนบ',
      branchId: 'สาขา',
      notes: 'หมายเหตุ',
      status: 'สถานะ',
      subtotal: 'ก่อนภาษี',
      vat: 'ภาษีซื้อ',
      total: 'รวม',
      wht: 'หัก ณ ที่จ่าย',
      whtCondition: 'เงื่อนไขการหักภาษี',
      whtBorne: 'ภาษีที่บริษัทออกให้',
      paidAmount: 'จ่ายแล้ว',
      outstanding: 'ค้างจ่าย',
      approvedByUserId: 'อนุมัติโดย',
      approvedAt: 'อนุมัติเมื่อ',
      submittedByUserId: 'ส่งอนุมัติโดย',
      opening: 'ยกยอดมา',
    },
    options: {
      status: { draft: 'ร่าง', pending: 'รออนุมัติ', approved: 'อนุมัติแล้ว รอจ่าย', partial: 'จ่ายบางส่วน', paid: 'จ่ายครบ', cancelled: 'ยกเลิก' },
      whtCondition: { withheld: 'หัก ณ ที่จ่าย', always: 'ออกให้ตลอดไป', once: 'ออกให้ครั้งเดียว' },
    },
    sections: { main: 'ใบตั้งหนี้', taxInvoice: 'ใบกำกับภาษีของผู้ขาย', lines: 'รายการ', other: 'อื่นๆ' },
    line: {
      account: 'บัญชีค่าใช้จ่าย',
      description: 'รายละเอียด',
      amount: 'จำนวนเงิน (ก่อน VAT)',
      vat: 'VAT',
      whtRate: 'หัก ณ ที่จ่าย',
      vehicle: 'รถ',
      add: 'เพิ่มรายการ',
      vatOptions: { vat7: '7%', none: 'ไม่มี' },
    },
    approve: 'อนุมัติให้จ่าย',
    approved: 'อนุมัติแล้ว',
    notYours: 'คนบันทึกอนุมัติเองไม่ได้',
    newVendor: 'ผู้ขายรายใหม่: ยังไม่เคยมีใบตั้งหนี้ที่อนุมัติแล้ว ตรวจว่ามีตัวตนจริงก่อนอนุมัติ',
    pay: 'จ่ายเงิน',
    advances: 'เงินจ่ายล่วงหน้าของใบนี้ (หักตอนจ่าย)',
    whtHint: 'อัตราหัก ณ ที่จ่าย: ค่าขนส่ง 1% · ค่าโฆษณา 2% · ค่าบริการและค่าจ้างทำของ 3% · ค่าเช่า 5% (ภาษีหักตอนจ่ายเงิน)',
    paySelected: 'จ่าย ({{count}})',
  },
  billPayment: {
    title: 'ใบสำคัญจ่าย',
    plural: 'ใบสำคัญจ่าย',
    create: 'จ่ายเงินผู้ขาย',
    fields: {
      number: 'เลขที่',
      paidOn: 'วันที่จ่าย',
      vendorId: 'ผู้ขาย',
      method: 'จ่ายโดย',
      reference: 'เลขรายการธนาคาร / เลขเช็ค',
      slipId: 'หลักฐานการโอน',
      attachments: 'เอกสารแนบ',
      allocations: 'ใบตั้งหนี้ที่จ่าย',
      notes: 'หมายเหตุ',
      settled: 'ตัดหนี้',
      whtAmount: 'หัก ณ ที่จ่าย',
      whtBorne: 'ภาษีที่บริษัทออกให้',
      whtCondition: 'เงื่อนไขการหักภาษี',
      paid: 'จ่ายจริง',
      whtForm: 'แบบยื่น',
      whtCertNo: 'เลขที่ 50 ทวิ',
      kind: 'ประเภท',
      advances: 'หักเงินจ่ายล่วงหน้า',
      amount: 'จำนวนเงิน',
      whtRate: 'หัก ณ ที่จ่าย (%)',
      payBank: 'ธนาคาร',
      payBankAccount: 'เลขบัญชี',
      payBankAccountName: 'ชื่อบัญชี',
      tripId: 'เที่ยวรถ',
      billId: 'ใบตั้งหนี้ที่หัก',
      advanced: 'หักเงินจ่ายล่วงหน้า',
      applied: 'หักไปแล้ว',
      unapplied: 'คงเหลือ',
      status: 'สถานะ',
    },
    options: {
      status: { draft: 'ร่าง', requested: 'รอส่งธนาคาร', sent: 'รอโอน', paid: 'จ่ายแล้ว', cancelled: 'ยกเลิก' },
      whtForm: { pnd3: 'ภ.ง.ด.3', pnd53: 'ภ.ง.ด.53' },
      kind: { payment: 'จ่ายชำระ', advance: 'จ่ายล่วงหน้า' },
      whtCondition: { withheld: 'หัก ณ ที่จ่าย', always: 'ออกให้ตลอดไป', once: 'ออกให้ครั้งเดียว' },
    },
    sections: { main: 'ใบสำคัญจ่าย', payTo: 'โอนเข้าบัญชี', allocations: 'ใบตั้งหนี้ที่จ่าย', other: 'อื่นๆ' },
    advancesTitle: 'หักเงินจ่ายล่วงหน้าของผู้ขายรายนี้',
    advancePaid: 'หัก ณ ที่จ่าย {{wht}} · โอนจริง {{paid}} บาท',
    noBills: 'ผู้ขายรายนี้ไม่มีใบตั้งหนี้ที่อนุมัติแล้วรอจ่าย',
    noBillsWaiting: 'มีใบตั้งหนี้รออนุมัติ {{count}} ใบ จ่ายได้เมื่ออนุมัติแล้ว',
    noBillsHint: 'บันทึกค่าใช้จ่ายเป็นใบตั้งหนี้แล้วให้อนุมัติก่อน หรือถ้าจ่ายก่อนมีใบตั้งหนี้ เปลี่ยนเป็นจ่ายล่วงหน้า',
    toAdvance: 'เปลี่ยนเป็นจ่ายล่วงหน้า',
    certificate: 'พิมพ์ 50 ทวิ',
    attachmentsHint: 'ใบเสร็จรับเงิน ใบกำกับภาษี หรือเอกสารอื่นจากผู้ขาย แนบเพิ่มได้หลังจ่ายแล้ว',
    voucher: 'พิมพ์ใบสำคัญจ่าย',
    /** A transfer set up in the bank, waiting for the owner to approve it there (`inBank`) */
    bank: {
      send: 'ส่งเข้าธนาคาร',
      sendHint: 'ตั้งรายการโอนในธนาคาร ใส่ข้อความด้านล่างในหมายเหตุ แล้วใส่เลขรายการที่ธนาคารให้',
      memo: 'หมายเหตุในธนาคาร',
      copy: 'คัดลอก',
      copied: 'คัดลอกแล้ว',
      reference: 'เลขรายการที่ธนาคารให้',
      sent: 'ส่งเข้าธนาคารแล้ว รอโอน (เลขรายการ {{reference}})',
      locked:
        'ส่งเข้าธนาคารแล้ว รอเจ้าของอนุมัติการโอน ระหว่างนี้ยอดและผู้รับเปลี่ยนไม่ได้ และใบตั้งหนี้ในใบนี้จ่ายซ้ำไม่ได้ เงินออกแล้วกด "โอนแล้ว" ถ้าธนาคารไม่ได้โอน กด "ไม่ได้โอน"',
      transferred: 'โอนแล้ว',
      transferredHint: 'ใส่วันที่เงินออกจริงตามสลิป ใบสำคัญจ่ายได้เลขที่ตามเดือนนั้น',
      transferredDone: 'ออกใบสำคัญจ่าย {{number}} แล้ว',
      notTransferred: 'ไม่ได้โอน',
      notTransferredTitle: 'ธนาคารไม่ได้โอนรายการนี้?',
      notTransferredBody: 'เลขรายการธนาคารจะถูกลบออก ใบนี้กลับเป็นร่าง และใบตั้งหนี้กลับไปรอจ่าย ถ้าไม่ต้องจ่ายแล้วให้ลบใบนี้ต่อ',
      inBank: 'รอโอนในธนาคาร {{reference}}',
    },
    /** Paying approved bills in one step (PayBillDialog) */
    pay: {
      title: 'จ่ายเงิน',
      bills: '{{count}} ใบ',
      due: 'ยอดที่ต้องจ่าย',
      owed: 'ค้างจ่าย {{amount}}',
      payTo: 'โอนเข้าบัญชี',
      otherAdvances: 'หักเงินจ่ายล่วงหน้าอื่นของผู้ขายด้วย (คงเหลือ {{amount}} บาท)',
      confirm: 'จ่ายและออกใบสำคัญจ่าย',
      send: 'ส่งเข้าธนาคาร',
      transferred: 'โอนไปแล้ว',
      transferredHint: 'เงินออกไปแล้วโดยไม่ผ่านการอนุมัติในธนาคาร เช่น เจ้าของโอนเองจากแอปธนาคาร: ใส่วันที่ เลขรายการ และสลิป ได้ใบสำคัญจ่ายทันที',
      done: 'ออกใบสำคัญจ่าย {{number}} แล้ว',
      detailed: 'จ่ายแบบละเอียด',
      waiting:
        'ใบนี้มีเงินเบิกล่วงหน้ารอโอน {{amount}} บาท ถ้าจ่ายใบตั้งหนี้ก่อน คนขับจะได้เงินซ้ำเมื่อโอนเบิก: โอนเบิกก่อนแล้วระบบหักให้ตอนจ่าย หรือลบใบเบิกถ้าไม่ต้องโอนแล้ว',
      openAdvance: 'เปิดใบเบิก {{amount}} บาท',
    },
  },
  journal: {
    date: 'วันที่',
    document: 'เอกสาร',
    description: 'คำอธิบาย',
    accountCode: 'รหัสบัญชี',
    accountName: 'ชื่อบัญชี',
    debit: 'เดบิต',
    credit: 'เครดิต',
  },
  payables: {
    nav: 'ฝั่งจ่าย',
    whtReport: 'ภาษีหัก ณ ที่จ่าย (ภ.ง.ด.3/53)',
    inputVat: 'รายงานภาษีซื้อ',
    whtReportDescription: 'ภาษีที่บริษัทหักจากผู้ขายในเดือน แยกตามแบบ ภ.ง.ด.3 และ ภ.ง.ด.53 ส่งออกเป็น Excel ไปยื่น',
    inputVatDescription: 'ใบตั้งหนี้ที่มี VAT และเลขที่ใบกำกับภาษี ตามเดือนของใบกำกับ',
    journal: 'สมุดรายวัน (ส่งสำนักงานบัญชี)',
    journalHint: 'รวมใบตั้งหนี้ ใบสำคัญจ่าย เงินสดย่อยจากสาขา เบิกค่าใช้จ่ายของพนักงาน งวดเงินเดือน และเงินเบิกล่วงหน้าของเดือน',
    unbalanced: 'มีรายการที่เดบิตไม่เท่าเครดิต: {{documents}}',
    omitted: 'ไม่รวม {{parts}} เพราะบัญชีนี้ไม่มีสิทธิ์ดูทั้งหมด',
    parts: { pettyCash: 'เงินสดย่อย', payroll: 'เงินเดือน', advances: 'เงินเบิกล่วงหน้า' },
  },
}

export const payablesEn = {
  opening: {
    title: 'Brought forward',
    hint: 'What customers still owe and what is still to pay on the day the system starts, from the old program or a spreadsheet. Old numbers kept; no new tax invoices; not in input VAT or the journal',
    kinds: { receivables: 'Receivables', payables: 'Payables' },
    kindHints: {
      receivables: 'Invoices customers have not paid: take their payments here as usual',
      payables: 'Bills not yet paid: they come in awaiting approval; once a manager approves them, pay them with payment vouchers',
    },
    col: {
      customerCode: 'Customer code',
      vendorCode: 'Supplier code',
      number: 'Old document no.',
      issueDate: 'Date',
      billDate: 'Date',
      dueDate: 'Due',
      amount: 'Outstanding (VAT in)',
      wht: 'Withholding',
      notes: 'Notes',
    },
  },
  account: {
    title: 'Account',
    plural: 'Chart of accounts',
    create: 'Add account',
    fields: { code: 'Code', name: 'Name', type: 'Type', system: 'Posted by the system', status: 'Status', notes: 'Notes' },
    options: {
      type: { asset: 'Asset', liability: 'Liability', equity: 'Equity', revenue: 'Revenue', expense: 'Expense' },
      status: { active: 'Active', inactive: 'Inactive' },
    },
    hint: 'Accounts the system posts to can be renamed, not re-coded or re-typed. Bills can use any expense account',
  },
  bill: {
    title: 'Bill',
    plural: 'Bills / expenses',
    create: 'Record expense',
    fields: {
      number: 'No.',
      vendorId: 'Supplier',
      billDate: 'Date',
      dueDate: 'Due',
      vendorInvoiceNo: "Supplier's tax invoice / bill no.",
      vendorInvoiceDate: 'Tax invoice date',
      lines: 'Lines',
      attachments: 'Attachments',
      branchId: 'Branch',
      notes: 'Notes',
      status: 'Status',
      subtotal: 'Before VAT',
      vat: 'Input VAT',
      total: 'Total',
      wht: 'Withholding',
      whtCondition: 'Withholding paid by',
      whtBorne: 'Tax borne by us',
      paidAmount: 'Paid',
      outstanding: 'Outstanding',
      approvedByUserId: 'Approved by',
      approvedAt: 'Approved',
      submittedByUserId: 'Submitted by',
      opening: 'Brought forward',
    },
    options: {
      status: {
        draft: 'Draft',
        pending: 'Awaiting approval',
        approved: 'Approved, to pay',
        partial: 'Part paid',
        paid: 'Paid',
        cancelled: 'Cancelled',
      },
      whtCondition: { withheld: 'Withheld', always: 'Borne by us, always', once: 'Borne by us, once' },
    },
    sections: { main: 'Bill', taxInvoice: "Supplier's tax invoice", lines: 'Lines', other: 'Other' },
    line: {
      account: 'Expense account',
      description: 'Description',
      amount: 'Amount (before VAT)',
      vat: 'VAT',
      whtRate: 'Withholding',
      vehicle: 'Vehicle',
      add: 'Add line',
      vatOptions: { vat7: '7%', none: 'None' },
    },
    approve: 'Approve for payment',
    approved: 'Approved',
    notYours: 'Whoever recorded it cannot approve it',
    newVendor: 'A new supplier: no bill of theirs has been approved yet. Check they are real before approving',
    pay: 'Pay',
    advances: 'Advances paid for this bill (set off when paying)',
    whtHint: 'Withholding: transport 1% · advertising 2% · services and hire of work 3% · rent 5% (taken when paying)',
    paySelected: 'Pay ({{count}})',
  },
  billPayment: {
    title: 'Payment voucher',
    plural: 'Payment vouchers',
    create: 'Pay a supplier',
    fields: {
      number: 'No.',
      paidOn: 'Paid on',
      vendorId: 'Supplier',
      method: 'Paid by',
      reference: 'Bank reference / cheque no.',
      slipId: 'Transfer slip',
      attachments: 'Attachments',
      allocations: 'Bills paid',
      notes: 'Notes',
      settled: 'Settled',
      whtAmount: 'Withheld',
      whtBorne: 'Tax borne by us',
      whtCondition: 'Withholding paid by',
      paid: 'Paid out',
      whtForm: 'Form',
      whtCertNo: '50 bis no.',
      kind: 'Kind',
      advances: 'Advances set off',
      amount: 'Amount',
      whtRate: 'Withholding (%)',
      payBank: 'Bank',
      payBankAccount: 'Account no.',
      payBankAccountName: 'Account name',
      tripId: 'Trip',
      billId: 'Bill it is set off against',
      advanced: 'Advances set off',
      applied: 'Set off so far',
      unapplied: 'Left',
      status: 'Status',
    },
    options: {
      status: { draft: 'Draft', requested: 'To put in the bank', sent: 'In the bank', paid: 'Paid', cancelled: 'Cancelled' },
      whtForm: { pnd3: 'P.N.D.3', pnd53: 'P.N.D.53' },
      kind: { payment: 'Payment', advance: 'Advance' },
      whtCondition: { withheld: 'Withheld', always: 'Borne by us, always', once: 'Borne by us, once' },
    },
    sections: { main: 'Payment voucher', payTo: 'Pay into', allocations: 'Bills paid', other: 'Other' },
    advancesTitle: 'This supplier’s advances to set off',
    advancePaid: 'Withheld {{wht}} · transferred {{paid}} baht',
    noBills: 'This supplier has no approved bills to pay',
    noBillsWaiting: '{{count}} of their bills await approval: they can be paid once approved',
    noBillsHint: 'Record the expense as a bill and have it approved first, or, paying before there is a bill, make this an advance',
    toAdvance: 'Make it an advance',
    certificate: 'Print 50 bis',
    attachmentsHint: "The supplier's receipt, tax invoice or other papers: more can be added after paying",
    voucher: 'Print voucher',
    bank: {
      send: 'Put in the bank',
      sendHint: "Set the transfer up in the bank with the text below as its note, then type the bank's reference",
      memo: 'Note in the bank',
      copy: 'Copy',
      copied: 'Copied',
      reference: "The bank's reference",
      sent: 'In the bank, waiting to be transferred (reference {{reference}})',
      locked:
        'Set up in the bank, waiting for the owner to approve the transfer: what it pays and to whom no longer change, and its bills cannot be paid again meanwhile. Once the money is out press "Transferred"; if the bank did not transfer it, press "Not transferred"',
      transferred: 'Transferred',
      transferredHint: 'The day the money went out, as on the slip: the voucher is numbered by its month',
      transferredDone: 'Payment voucher {{number}} issued',
      notTransferred: 'Not transferred',
      notTransferredTitle: 'The bank did not transfer it?',
      notTransferredBody:
        "The bank's reference is taken off, this goes back to a draft and its bills to be paid. Delete it next if it is no longer to be paid",
      inBank: 'In the bank, {{reference}}',
    },
    pay: {
      title: 'Pay',
      bills: '{{count}} bills',
      due: 'To pay',
      owed: 'Outstanding {{amount}}',
      payTo: 'Transfer into',
      otherAdvances: 'Set off the supplier’s other advances too ({{amount}} THB left)',
      confirm: 'Pay and issue the voucher',
      send: 'Put in the bank',
      transferred: 'Transferred already',
      transferredHint:
        "The money is out without the bank's approval step (the owner paid it from the bank's app): its day, reference and slip, and the voucher is issued now",
      done: 'Payment voucher {{number}} issued',
      detailed: 'More options',
      waiting:
        'An advance of {{amount}} THB for this is still to transfer. Paid first, the bill would pay the driver twice once the advance goes out: transfer the advance first and it is set off here, or delete it if it is no longer needed',
      openAdvance: 'Open the advance ({{amount}} THB)',
    },
  },
  journal: {
    date: 'Date',
    document: 'Document',
    description: 'Description',
    accountCode: 'Account',
    accountName: 'Account name',
    debit: 'Debit',
    credit: 'Credit',
  },
  payables: {
    nav: 'Payables',
    whtReport: 'Withholding tax (P.N.D.3/53)',
    inputVat: 'Input VAT report',
    whtReportDescription: 'Tax withheld from vendors in the month, by P.N.D.3 and P.N.D.53, exported to Excel for filing',
    inputVatDescription: "Bills with VAT and a tax invoice number, by the tax invoice's month",
    journal: 'Journal (for the accounting firm)',
    journalHint: "The month's bills, payment vouchers, branch petty cash, staff expense claims, pay runs and salary advances",
    unbalanced: 'Debits and credits differ for: {{documents}}',
    omitted: 'Leaves out {{parts}}: this account may not see all of it',
    parts: { pettyCash: 'petty cash', payroll: 'pay runs', advances: 'salary advances' },
  },
}
